import React, { useEffect } from "react";
const urlPrefix = "http://localhost:8888";

const RichContentImage = ({
  content,
  type,
  scrollToBottom,
  width = "90%", // Configurable width
  maxWidth = "400px", // Configurable max width
  borderRadius = "10px", // Configurable border radius
  altText = "Rich content image", // Configurable alt text
}) => {
  function prefixUrlIfNeeded(url) {
    /* Vik (May 7, 2025): Check if the URL starts with 'https' */
    if (url.startsWith("https://")) {
      return url;
    }
    // If no 'https', add 'https://' prefix
    return `${urlPrefix}${content.rawUrl}`;
  }

  useEffect(() => {
    if (scrollToBottom) {
      // setTimeout(scrollToBottom, 2000);
      // setTimeout(scrollToBottom, 3000);
      scrollToBottom();
    }
  }, []);

  return (
    <a
      href={content.link}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        marginTop: "10px",
        display: "flex",
        justifyContent: content.isFirstImage ? "center" : "start", // Vik (May 12, 2025): first image to be visible centered
      }}
    >
      <img
        src={prefixUrlIfNeeded(content.rawUrl)}
        style={{
          width: "90%",
          // maxWidth,
          height: "auto",
          display: "block",
          borderRadius,
        }}
        alt={altText}
      />
    </a>
  );
};

export default RichContentImage;
